import barba from '@barba/core';
import emitter from 'tiny-emitter/instance';
import $ from 'jquery';
import Utils from '../utils/utils';
import PageTransition from '../interface/pageTransition'

class BulbPageTransition{

    constructor(bulb){
      Utils.debug('BulbPageTransition : Construct');

      this.bulb = bulb;
      this.imagesAlreadyLoaded = []
      this.scrollY = false
      this.linkClicked = false
      this.pageTransition = new PageTransition()

      // on va charger barba uniquement si nous ne sommes pas logué au backend (cf https://roots.io/guides/using-barba-js-with-sage-9/ #Issue 1)
      $.post(window.ajax_object.ajax_url, {action: 'is_user_logged_in'},  (isLogged) => {
        if (! parseInt(isLogged)) {
          this.init();
        }
      });

    }

    init(){

        let _self = this;

        emitter.on('cookie::Enabled', () => {
          console.error('emitter ---> cookie::Enabled');
          // analytics events
          this.bulb.trackerInit();
        });

        emitter.on('cookie::Disabled', () => {
          // analytics events
          this.bulb.trackerRemove();
        });



        // On va configurer notre BarbaJs de manière assez minimaliste, pour qu'il fonctionne avec Analytics et Locomotive Scroll
        barba.hooks.beforeLeave(() => {
            // petit evenement catchable pas notre appli au besoin
            emitter.emit('barba::beforeLeave');

            // on destroy bulb scroll
            if(this.bulb.cursor !== undefined) {
                this.bulb.scroll.destroy();

                // on reset les modules
                this.bulb.cursor.resetCursor();
            }
            this.bulb.modules.destroy();
        });



        barba.hooks.after((data) => {

            // this.bulb.getDevice()
            this.refreshCustomHtml(data);
            // petit evenement catchable pas notre appli au besoin
            emitter.emit('barba::after');

            // on re init locotomtive scroll
            this.bulb.scroll.init();
            // on re init la gestion des module
            this.bulb.modules.init(this.bulb.modules);
            // on va réinit les zones réactives pour le cursuer sur ce qui arrive en ajax
            if(this.bulb.cursor !== undefined) {
                this.bulb.cursor.initReactiveAreaEvents(data.next.container);
                this.bulb.cursor.resetCursor();
            }
            // on envoie un event analytics car rechargement en ajax
            this.bulb.trackPageView();

        });

        // C'est la transition par defaut un volet qui masque le site pour laisser apparaitre la nouvelle page
        barba.init({
            debug: true,
            transitions: [{
                name: 'default',
                once() {
                    if ('scrollRestoration' in history) {
                        history.scrollRestoration = 'manual';
                    }
                },
                beforeLeave() {
                    if (!_self.scrollY) {
                        _self.scrollY = barba.history.current.scroll.y
                    }
                },
                afterLeave(data) {
                    // Register data trigger
                    //si on a pas cliqué sur un lien (donc click sur back boutton navigateur ou boutton magnetic back)
                    _self.linkClicked = !(data.trigger === 'back' || data.trigger === 'barba');

                    return _self.pageTransition.openTransition();
                },
                beforeEnter(data) {
                    data.current.container.remove()
                },
                enter() {
                    if(_self.bulb.scroll) {
                        _self.bulb.scroll.destroy();
                    }
                    return true
                },

                after(data){
                    _self.pageTransition.loadAsset(data.next.html)
                    if(data.next.url.hash === undefined) {
                        if (_self.linkClicked) {
                            // Scroll top of page
                            window.scroll(0, 0);
                        }
                        else if (_self.scrollY) {
                            // Scroll back to Y position
                            window.scroll(0, _self.scrollY);
                            _self.scrollY = false;
                        }
                        else {
                            window.scroll(0, 0);
                        }
                    }
                    if(_self.bulb.scroll) {
                        _self.bulb.scroll.init();
                    }

                },
            }],
        })
    }

    /**
     * Permet de refresh des datas provenant de la page arrivante
     * Dans notre cas, on met à jours la classe du body, et on injuecte les styles "inlines" d'elementor
     * @param data
     */
    refreshCustomHtml(data){

      // console.debug(data);

      // on replace le lien des langues (qui change a chaque chargement de page)
      let htmlObject = document.createElement('html');
      htmlObject.innerHTML = data.next.html;
      $('.navbar-language').html($(htmlObject).find('.navbar-language').html());

      // on charge les styles iliens d'elementor
      const regex = /<style id='elementor-frontend-inline-css' type='text\/css'>(.|\n)*?<\/style>/gm;
      let result = data.next.html.match(regex);
      if(result !== null && result.length > 0) {
          $('#elementor-frontend-inline-css').replaceWith(result[0]);
      }

      // on ajoute la classe du body, on utiliser un data attribute pour ne pas avoir a parsedom tout le body tout la nouvelle page dans ce cas la
      // probleme de perf sur lanouvelle
      let newClassesToInject  = data.next.container.dataset.bodyClass;
      $('body').removeClass().addClass(newClassesToInject);

    }



}


export default BulbPageTransition;




// WEBPACK FOOTER //
// ./scripts/core/bulbPageTransition.js